import { EKYCStatus, schemes, zSchema } from "@zeal/common";

export const updateCompanyKYCStatusRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  kyc_status: zSchema.nativeEnum(EKYCStatus),
});

export type TUpdateCompanyKYCStatusRequest = zSchema.infer<
  typeof updateCompanyKYCStatusRequestSchema
>;

export type TUpdateCompanyKYCStatusResponse = zSchema.infer<
  typeof updateCompanyKYCStatusRequestSchema
>;
